import React from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, Divider, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PersonalSessionInfo = () => {
  return (
    <Box sx={{ py: 6, px: { xs: 2, md: 8 }, bgcolor: 'background.default', color: 'text.primary' }}>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, md: 5 },
          mx: 'auto',
          borderRadius: 2,
          bgcolor: 'white',
          boxShadow: 3,
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography
            variant="h3"
            component="h2"
            
            fontWeight={400}
            color="text.primary"
            sx={{ fontSize: { xs: 28, md: 36 } }}
          >
            <strong>One-on-One Positive Psychology Session</strong>
          </Typography>
        </Box>
        <Typography  color="text.secondary" sx={{ mb: 3, fontSize: { xs: 16, md: 18 } }}>
          A personalized one-on-one session designed to support your journey toward self-awareness, balance, and growth. Together, we’ll explore your mindset, values, and everyday challenges, and apply science-based Positive Psychology tools to help you create meaningful change in your life as a woman or mother — while guiding you to raise happier, more resilient kids.
        </Typography>

        <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
          <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'custom.beige', border: '1px solid', borderColor: 'custom.yellow' }}>
            <Typography variant="h6"  fontWeight={700} color="text.primary">
              Standard Session: $ 97
            </Typography>
            <Typography  color="text.secondary">
              (50-60 minutes)
            </Typography>
          </Box>

          <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'custom.beige', border: '1px solid', borderColor: 'custom.yellow' }}>
            <Typography variant="h6"  fontWeight={700} color="text.primary">
              Premium Package: $ 388
            </Typography>
            <Typography  color="text.secondary">
              4 Sessions (50-60 minutes each)
            </Typography>
            <Typography  sx={{ mt: 1 }}>
              Bonuses:
            </Typography>
            <List dense sx={{ pl: 2 }}>
              <ListItem sx={{ py: 0 }}>
                <ListItemText
                  primary="E-mail and WhatsApp Access for Follow-Up & Questions"
                  primaryTypographyProps={{ fontFamily: 'inherit' }}
                />
              </ListItem>
            </List>
          </Box>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'custom.blue', color: 'text.primary', mt: 3 }}>
          <Typography sx={{ mb: 1 }}>
            *For those residing in Lebanon, please contact me directly for pricing.
          </Typography>

          <Typography fontWeight={700} sx={{ mb: 1 }}>
            Note:
          </Typography>
          <Typography sx={{ mb: 1 }}>
            Services are payable at the beginning of each contract period.
          </Typography>
          <Typography>
            Payments can be made through Whish/OMT or PayPal. Please contact Sara to arrange payment first.
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Once payment is arranged, you can book your session directly through this link:
            <Link href="https://calendly.com/positive-psychology-sessions/positive-psychology-1-1-session" target="_blank" rel="noopener noreferrer" sx={{ ml: 0.5, fontWeight: 700, color: "black" }}>
              Book Your Session on Calendly
            </Link>
            .
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Please send me a message to arrange your session or package —
            <Link component={RouterLink} to="/contact" sx={{ ml: 0.5, fontWeight: 700, color: 'black' }}>
              contact me here
            </Link>
            .
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default PersonalSessionInfo;
